<template>
  <div class="sdata">
    <div class="sdata__eprice">
      <div class="sdata__eprice-title" v-if="!countryDateFilled">Укажите страны и даты поездки, чтобы узнать цену</div>
      <Transition name="fade">
        <div v-if="countryDateFilled">
          <div class="sdata__eprice-title">Расчёт страхования на {{ count }} {{ word }}</div>
          <div class="sdata__bigtext sdata__eprice-price">{{fullprice}} ₽</div>
        </div>
      </Transition>
    </div>
    <div class="step__divideline step__divideline_shrinking"></div>
    <div class="sdata__info">
      <div class="sdata__bigtext sdata__info-title">
        {{ form.travel.insurancesum }} {{ form.travel.currency }}, <br class="calc-disappearing">{{ form.travel.resttype.toLowerCase() }}
      </div>
      <div class="sdata__text">В страховку включено:</div>
      <div class="sdata__text">Амбулаторное лечение, экстренная стоматология, госпитализация, вызов врача.</div>
      <a class="newred sdata__text" :href="descrurl">Полное описание покрытия</a>
    </div>
    <div class="step__divideline step__divideline_shrinking"></div>
    <Transition name="fade">
      <div class="sdata__details" v-if="countryDateFilled">
        <div class="sdata__text calc-disappearing">Детали страхования:</div>
        <div class="sdata__bigtext">Стран{{ form.travel.countries.length == 1 ? 'а' : 'ы' }} поездки: {{ form.travel.countries.join(', ') }}</div>
        <div class="sdata__text">Даты поездки: {{ form.travel.dates.replace(/\s/g, '') }}</div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  data: ()=>({
    price: 0
    // price: 1000
  }),
  computed: {
    ...mapState(['descrurl', 'addonsPrice', 'form', 'countryDateFilled']),
    ...mapGetters(['personsCount']),
    count() {
      return this.personsCount
    },
    word() {
      if (this.count < 5) return 'человека'
      return 'человек'
    },
    fullprice(){
      return (this.price + this.addonsPrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    }
  },
}
</script>

<style lang="sass" scoped>
.sdata
  color: colors.$gray5
  line-height: 1.12
  &__eprice
    &-title
      font-weight: 500
      font-size: 14px
      margin-bottom: 8px
  &__bigtext
    font-weight: 500
    font-size: 20px
    line-height: 1.18
    color: colors.$gray3
  &__text
    font-size: 14px
    margin: 16px 0
    @include from(820px)
      margin: 8px 0

</style>